import { defineNuxtPlugin } from 'nuxt/app'
import Toast, { useToast } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export default defineNuxtPlugin((nuxtApp) => {
  // Install toastification globally
  nuxtApp.vueApp.use(Toast, {
    transition: 'Vue-Toastification__bounce',
    maxToasts: 20,
    newestOnTop: true,
    timeout: 4000,
   position: "bottom-center",
   closeOnClick: true,
  })

  // Make it available everywhere as $toast
  return {
    provide: {
      toast: useToast()
    }
  }
})
